export default {"src":"/_next/static/media/arrow_left_gold_2.bc6107c4.svg","height":47,"width":48,"blurWidth":0,"blurHeight":0};